import { render, staticRenderFns } from "./authSuccess.vue?vue&type=template&id=6ca53f04&scoped=true"
import script from "./authSuccess.vue?vue&type=script&lang=js"
export * from "./authSuccess.vue?vue&type=script&lang=js"
import style0 from "./authSuccess.vue?vue&type=style&index=0&id=6ca53f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca53f04",
  null
  
)

export default component.exports